<template>
  <div class="m-3">
    <h3>Add New Product</h3>
    <AddElement category_id="7"></AddElement>
  </div>
</template>

<script>
import AddElement from "@/components/ElementComponents/AddElement.vue";

export default {

  name: "AddNewProduct",
  components: {
    AddElement,
  },
  data() {
    return {};
  },
};
</script>